import * as React from 'react';
import {connect} from 'react-redux';

import type {EntityFormType} from '../creator/types';
// @ts-expect-error
import * as dashboardActions from '../master-dashboard/dashboard-actions';
import {TaskFormWrapper} from '../tasks/task-form-wrapper';

import {AccountForm, ContactForm, LeadForm, ActivityForm, SalesDocumentForm} from './forms';

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        refreshDashes: () => {
            dispatch(dashboardActions.fetchDashboardComponentData());
        },
    };
}

type OwnProps = {
    entityType: EntityFormType | null | undefined;
    entityId: string | null | undefined;
    disabled: boolean;
    onCancelClick: () => any;
    onSave: (entity: any, jumpToUrl: boolean) => any;
};

type DispatchProps = {
    refreshDashes: () => any;
};

type Props = OwnProps & DispatchProps;

export class EntityFormComponent extends React.Component<Props> {
    render() {
        if (!this.props.entityType) return null;

        if (this.props.entityType === 'contacts') {
            return (
                <ContactForm
                    onSaveCallback={this.handleSave}
                    onCancelClick={this.props.onCancelClick}
                />
            );
        }

        if (this.props.entityType === 'accounts') {
            return (
                <AccountForm
                    onSaveCallback={this.handleSave}
                    onCancelClick={this.props.onCancelClick}
                />
            );
        }

        if (this.props.entityType === 'activities') {
            return (
                <ActivityForm
                    onSaveCallback={this.handleSave}
                    onCancelClick={this.props.onCancelClick}
                />
            );
        }

        if (this.props.entityType === 'leads') {
            return (
                <LeadForm
                    onSaveCallback={this.handleSave}
                    onCancelClick={this.props.onCancelClick}
                />
            );
        }

        if (this.props.entityType === 'tasks') {
            return (
                <TaskFormWrapper
                    form={
                        this.props.entityId ? `${this.props.entityId}-modal` : 'task_creation_modal'
                    }
                    taskId={this.props.entityId}
                    onCancelClick={this.props.onCancelClick}
                    onSaveCallback={this.handleSave}
                    isReadOnly={this.props.disabled}
                />
            );
        }

        if (this.props.entityType === 'quotes') {
            return <SalesDocumentForm entityType='QUOTE' />;
        }

        if (this.props.entityType === 'invoices') {
            return <SalesDocumentForm entityType='INVOICE' />;
        }

        return null;
    }

    handleSave = (entity: any, jumpToUrl: boolean) => {
        if (entity.type === 'tasks' || entity.type === 'activities') {
            this.props.refreshDashes();
        }

        this.props.onSave(entity, jumpToUrl);
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);
export const EntityForm = connector(EntityFormComponent);
